export { formatGroupLabel } from './formatGroupLabel'
